import { cloneDeep } from 'lodash';
const parseHtml = htmlString => {
  const parser = new DOMParser();
  return parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
};
const defaultProperties = {
  title: 'Freestyle Section',
  settings: {
    paddingTop: true,
    paddingBottom: true,
    backgroundColor: '#FFFFFF',
    textColor: '#000000',
    overlayColor: '#000000',
    overlayOpacity: 0,
    showOverlay: false,
    backgroundImage: '',
    useCustomWidth: false,
    customWidth: 1204,
  },
  containerPage: {
    enableStyle: false,
    background: '#FFFFFF',
  },
};

export const extractContainerFuild = htmlString => {
  const doc = parseHtml(htmlString);
  const result = {
    ...cloneDeep(defaultProperties),
  };
  const sectionEl = doc.querySelector('[data-section]');
  if (sectionEl) {
    result.title = sectionEl.getAttribute('data-title') || result.title;
  }
  const cardContainer = doc.querySelector('[data-attribute="card-container"]');
  if (cardContainer) {
    result.settings.backgroundColor = cardContainer.getAttribute('data-background') || '#FFFFFF';
    result.settings.textColor = cardContainer.getAttribute('data-text-color') || '#000000';
    result.settings.paddingTop = cardContainer.getAttribute('data-top-padding') === 'true' ? true : false;
    result.settings.paddingBottom = cardContainer.getAttribute('data-bottom-padding') === 'true' ? true : false;
    result.settings.overlayColor = cardContainer.getAttribute('data-overlay-color') || '#000000';
    result.settings.overlayOpacity = cardContainer.getAttribute('data-overlay-opacity') || 0;
    result.settings.showOverlay = cardContainer.getAttribute('data-show-overlay') === 'true' ? true : false;
    result.settings.backgroundImage = cardContainer.getAttribute('data-background-image') || '';
  }
  const containerPage = doc.querySelector('[data-attribute="container-page"]');
  if (containerPage) {
    result.containerPage.enableStyle = containerPage.getAttribute('data-enable-style') === 'true';
    result.containerPage.background = containerPage.getAttribute('data-background-container') || '#FFFFFF';
  }
  const containerContent = doc.querySelector('[data-attribute="container-content"]');
  if (containerContent) {
    result.settings.useCustomWidth = containerContent.getAttribute('data-use-custom-width') === 'true' ? true : false;
    result.settings.customWidth = containerContent.getAttribute('data-custom-width') || 1204;
  }
  return {
    result,
    doc,
  };
};
export const updateContainerFuild = (htmlString, updatedData) => {
  const doc = parseHtml(htmlString);
  const container = doc.body.firstElementChild;
  for (const key in updatedData) {
    switch (key) {
      case 'title': {
        const elTitle = container.querySelector('[data-attribute="section-title"]');
        if (elTitle) {
          elTitle.setAttribute('data-title', updatedData[key]);
        }
        break;
      }
      case 'settings': {
        const cardContainer = container.querySelector('[data-attribute="card-container"]');
        const overlayBgEl = container.querySelector('[data-attribute="overlay-bg"]');
        const containerContent = container.querySelector('[data-attribute="container-content"]');

        if (overlayBgEl) {
          overlayBgEl.style.display = updatedData[key]['showOverlay'] ? 'block' : 'none';
        }
        if (cardContainer) {
          cardContainer.setAttribute('data-background-image', updatedData[key]['backgroundImage']);
          cardContainer.style.backgroundImage = updatedData[key]['backgroundImage']
            ? `url(${updatedData[key]['backgroundImage']})`
            : '';
          cardContainer.setAttribute('data-top-padding', updatedData[key]['paddingTop'] ? 'true' : 'false');
          cardContainer.setAttribute('data-bottom-padding', updatedData[key]['paddingBottom'] ? 'true' : 'false');
          cardContainer.setAttribute('data-background', updatedData[key]['backgroundColor']);
          cardContainer.setAttribute('data-text-color', updatedData[key]['textColor']);
          cardContainer.style.backgroundColor = updatedData[key]['backgroundColor'];
          cardContainer.style.color = updatedData[key]['textColor'];
          cardContainer.style.setProperty('--text-color', updatedData[key]['textColor']);

          cardContainer.setAttribute('data-overlay-color', updatedData[key]['overlayColor']);
          cardContainer.setAttribute('data-overlay-opacity', updatedData[key]['overlayOpacity']);
          cardContainer.setAttribute('data-show-overlay', updatedData[key]['showOverlay'] ? 'true' : 'false');
          cardContainer.style.setProperty('--overlay-color', updatedData[key]['overlayColor']);
          cardContainer.style.setProperty('--overlay-opacity', updatedData[key]['overlayOpacity']);
        }
        if (containerContent) {
          containerContent.setAttribute('data-use-custom-width', updatedData[key]['useCustomWidth'] ? 'true' : 'false');
          containerContent.setAttribute('data-custom-width', updatedData[key]['customWidth']);
          containerContent.style.setProperty('--custom-width', updatedData[key]['customWidth'] + 'px');
        }
        break;
      }
      case 'containerPage': {
        const containerPage = container.querySelector('[data-attribute="container-page"]');
        if (containerPage) {
          containerPage.setAttribute('data-enable-style', updatedData[key]['enableStyle'] ? 'true' : 'false');
          containerPage.setAttribute('data-background-container', updatedData[key]['background']);
          containerPage.style.backgroundColor = updatedData[key]['enableStyle']
            ? updatedData[key]['background']
            : 'transparent';
        }
        break;
      }
    }
  }
  return container;
};
